/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import {
  type Signal,
  signal,
  computed,
  type ReadonlySignal,
} from '@preact/signals-react'

import type {
  TConvocatoriasState,
  TConvocatoria,
  TFormOption,
} from '@/interfaces'

const convocatorias: Signal<TConvocatoria[]> = signal([])

const currentConvocatoria: Signal<TConvocatoria> = signal({})

const currentCity: Signal<string | null> = signal(null)

const cities: ReadonlySignal<TFormOption[]> = computed(() => {
  return (
    currentConvocatoria.value?.municipiosParticipantes?.map((item) => {
      item.label = item.label.toUpperCase()

      return item
    }) ?? []
  )
})

export const ConvocatoriasState: TConvocatoriasState = {
  cities,
  convocatorias,
  currentCity,
  currentConvocatoria,
}
